import "../../../resources/less/Family/ThemePages/LeCanada.less";
import BaseThematique from "./BaseThematique";

class LeCanada extends BaseThematique {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new LeCanada();
});
